// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RTl0C","question":"styles_question__LhXGW","inputVisibleButton":"styles_inputVisibleButton__1MWSd","note":"styles_note__2LIPJ"};